import { useEffect, useRef, useState } from 'react';
import { useAnimate } from 'framer-motion';
import { clsx } from 'clsx';
import { TRUSTED_BY_IMAGES_URLS } from 'src/components/ClientsSlider/TrustedByImagesUrls';

export const ClientsSlider = () => {
  const [isHoverImage, setIsHoverImage] = useState(false);
  const [scope, animate] = useAnimate();
  const scrollDivRef = useRef(null);
  const animationRef = useRef(null);

  const handleHoverImage = () => {
    setIsHoverImage(true);
  };
  const handleLeaveImage = () => {
    setIsHoverImage(false);
  };
  const handleTouchImage = () => {
    setIsHoverImage((prevState) => !prevState);
  };

  useEffect(() => {
    if (scrollDivRef.current) {
      animationRef.current = animate(
        scrollDivRef.current,
        { x: ['0%', '-50%'] },
        {
          ease: 'linear',
          duration: 60,
          repeat: Infinity,
        },
      );
    }

    return () => {
      if (animationRef.current) {
        animationRef.current.stop();
      }
    };
  }, [animate]);

  useEffect(() => {
    if (animationRef.current) {
      if (isHoverImage) {
        animationRef.current.pause();
      } else {
        animationRef.current.play();
      }
    }
  }, [isHoverImage]);

  return (
    <div className="w-full mt-[32px]">
      <div className={'flex flex-row gap-5 items-center'}>
        <div className="flex flex-1 pl-5 font-jamjuree text-xs text-ebony_opacity_40 text-center font-medium text-nowrap items-center">
          <p>Trusted by:</p>
        </div>
        <div className="flex overflow-hidden relative">
          <div className="flex" ref={scope}>
            <div className="flex" ref={scrollDivRef}>
              <div className="flex gap-6 mr-6 w-[4100px]">
                {[...TRUSTED_BY_IMAGES_URLS, ...TRUSTED_BY_IMAGES_URLS].map((image, index) => (
                  <div key={`${index}-${image.url}`} className="flex items-center">
                    <img
                      width="130"
                      height="64"
                      alt={`logo-img-${image.url}`}
                      onTouchStart={handleTouchImage}
                      onMouseEnter={handleHoverImage}
                      onMouseLeave={handleLeaveImage}
                      src={image.url}
                      className={clsx(
                        'object-contain w-auto h-auto transition-all duration-300 hover:opacity-100 opacity-50',
                      )}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
